import { RunningDays } from "./RunningDays";
export const RunningDaysLabels = {
  [RunningDays.WORKING_DAYS]: "Working Days",
  [RunningDays.CALENDAR_DAYS]: "Calendar Days"
};
